import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import vuetify from './plugins/vuetify';
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es.js";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
window.$ = window.jQuery = require('jquery')

import interceptors from '@/helpers/interceptors'
import GlobalComponents from './globalComponents'
Vue.use(GlobalComponents);

import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from 'v-mask'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  },
});

interceptors()

// Vue analytics
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-XXX-X'
// })

Vue.use(VeeValidate);
Validator.localize("es", es);

const options = {
  confirmButtonColor: '#f5b6c1',
  cancelButtonColor: '#14365b',
};

Vue.use(VueSweetalert2, options);

Vue.config.productionTip = false
Vue.use(VueMask)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
